module.exports = "<div *ngIf=\"showSpinner\" class=\"\">\r\n    <img src=\"assets/images/icones/sample-spinner.gif\" />\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.component.html
// module id = ./src/app/shared/spinner/spinner.component.html
// module chunks = main